"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BILLING_FETCHER = exports.BILLING_SUMMARY_ERROR = exports.BILLING_ERROR = exports.BILLING_HISTORY = void 0;
exports.BILLING_HISTORY = 'billing-history';
exports.BILLING_ERROR = 'billing-error';
exports.BILLING_SUMMARY_ERROR = 'billing-summary-error';
exports.BILLING_FETCHER = {
    LEGACY: 'billing-legacy-fetcher',
    KAPI: 'billing-kapi-fetcher',
};
